import React from 'react';
import { useState } from 'react';
import { useZxing } from "react-zxing";

export const BarcodeScanner = ({handleResult}) => {
  const [result, setResult] = useState("");
  const { ref } = useZxing({
    onDecodeResult(result, el) {
        handleResult(result, el);
    },
  });

  return (
    <>
      <video ref={ref} />
    </>
  );
};